export default {
    saveNewTypeDance(state, typeDancePayload) {
        state.typesDance.push(typeDancePayload);
    },
    setTypesDance(state, typesDance) {
        state.typesDance = typesDance;
    },
    setFetchTimestamp(state) {
        state.lastFetch = new Date().getTime();
    },
    clearData(state) {
        state.typesDance = [];
        state.lastFetch = null;
    },
    setTypeDanceToEdit(state, payload) {
        state.typeDanceToEdit = payload;
    },
    updateTypeDanceInList(state, updatedTypeDance) {
        state.typesDance = state.typesDance.map(td =>
            td._id === updatedTypeDance._id ? updatedTypeDance : td
        );
    },
    removeTypeDance(state, typeDanceId) {
        state.typesDance = state.typesDance.filter(td => td._id !== typeDanceId);
    },
}